import { ThemeToggle } from '@/components/ThemeToggle'
import { Button } from '@/components/ui/button'
import { RESUME_PDF_PATH, resumeViewModel } from '@/data/resume'
import { Cpu, FileText, Linkedin, Mail } from 'lucide-react'

export function Header() {
  const { contact } = resumeViewModel

  return (
    <header className="sticky top-0 w-full z-40 border-b glass">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between gap-3">
          <div className="flex min-w-0 items-center gap-3">
            <div className="size-10 shrink-0 rounded-xl bg-primary flex items-center justify-center">
              <Cpu className="w-6 h-6 text-primary-foreground" aria-hidden="true" />
            </div>
            <div className="min-w-0">
              <h1 className="font-bold text-lg tracking-tight whitespace-nowrap">
                {resumeViewModel.name}
              </h1>
              <p className="meta-label text-blue-600 dark:text-blue-400 -mt-1 whitespace-nowrap">
                <span className="inline min-[540px]:hidden">Mechatronics</span>
                <span className="hidden min-[540px]:inline">Mechatronics Portfolio</span>
              </p>
            </div>
          </div>

          <nav
            className="hidden lg:flex items-center gap-2 xl:gap-3 flex-none"
            aria-label="Primary"
          >
            <a
              href="#experience"
              className="inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-full px-3 py-1.5 text-sm font-medium text-slate-700 dark:text-slate-300 transition-colors hover:bg-blue-50 hover:text-blue-700 dark:hover:bg-blue-900/30 dark:hover:text-blue-300"
            >
              Experience
            </a>
            <a
              href="#projects"
              className="inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-full px-3 py-1.5 text-sm font-medium text-slate-700 dark:text-slate-300 transition-colors hover:bg-blue-50 hover:text-blue-700 dark:hover:bg-blue-900/30 dark:hover:text-blue-300"
            >
              Projects
            </a>
            <a
              href="#credentials"
              className="inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-full px-3 py-1.5 text-sm font-medium text-slate-700 dark:text-slate-300 transition-colors hover:bg-blue-50 hover:text-blue-700 dark:hover:bg-blue-900/30 dark:hover:text-blue-300"
            >
              Credentials
            </a>
            <a
              href="#skills"
              className="inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-full px-3 py-1.5 text-sm font-medium text-slate-700 dark:text-slate-300 transition-colors hover:bg-blue-50 hover:text-blue-700 dark:hover:bg-blue-900/30 dark:hover:text-blue-300"
            >
              Skills
            </a>
            <a
              href="#fit-check"
              className="inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-full px-3 py-1.5 text-sm font-medium text-slate-700 dark:text-slate-300 transition-colors hover:bg-blue-50 hover:text-blue-700 dark:hover:bg-blue-900/30 dark:hover:text-blue-300"
            >
              Fit Check
            </a>
          </nav>

          <div className="flex shrink-0 items-center gap-2 sm:gap-3">
            <Button
              asChild
              size="sm"
              variant="outline"
              className="inline-flex shrink-0 rounded-full h-9 w-9 px-0 min-[540px]:w-auto min-[540px]:px-3 sm:px-4 whitespace-nowrap"
            >
              <a
                href={RESUME_PDF_PATH}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Open resume PDF"
                title="Open resume PDF"
              >
                <FileText className="w-4 h-4 min-[540px]:mr-1.5" />
                <span className="hidden sm:inline">Resume PDF</span>
                <span className="hidden min-[540px]:inline sm:hidden">Resume</span>
              </a>
            </Button>
            <div className="flex shrink-0 items-center gap-1 border-r pr-2 sm:pr-3">
              <Button asChild variant="ghost" size="icon">
                <a
                  href={contact.linkedinUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Open LinkedIn profile"
                  title="LinkedIn"
                >
                  <Linkedin className="w-4 h-4" />
                </a>
              </Button>
              <Button asChild variant="ghost" size="icon">
                <a href={`mailto:${contact.email}`} aria-label="Send email" title="Email Eric">
                  <Mail className="w-4 h-4" />
                </a>
              </Button>
            </div>
            <ThemeToggle className="relative top-0 right-0 shrink-0" />
          </div>
        </div>
      </div>
    </header>
  )
}
